<template>
	<div class="">
		<base-page-heading
			title="Flex Group"
			subtitle=""
			class="d-print-none"
		>
			<template #extra>
				<b-button
					ref="flexGroupShow"
					type="submit"
					size="md"
					variant="secondary"
					@click="showModal"
				>
					<i class="fa fa-fw fa-plus" /> 	Create new
				</b-button>
			</template>
		</base-page-heading>

		<div class="row">
			<FlexGroupTable @routeFlexGroup="routeFlexGroup" />
		</div>
	</div>
</template>
